<template lang="pug">
  v-row
    v-col.px-1(
      v-for="(model, i) in models"
      :key="i"
      :cols="12 / length")
      v-text-field(
        :disabled="loading"
        outlined
        type="tel"
        hide-details
        :autofocus="i === 0"
        :ref="`input-${i}`"
        @input="onInput(i)"
        @keydown="onKeyDown($event, i)"
        v-model.number="models[i]"
        v-mask="mask"
        :error="!!error")
    v-fade-transition(v-if="loading")
      v-col(:cols="12")
        v-progress-linear(indeterminate)
    v-fade-transition(v-if="error")
      v-col(:cols="12")
        v-alert(type="error") {{ error }}
</template>

<script>
import Vue from 'vue'
import { reactive, toRefs, ref, onMounted, watch } from '@vue/composition-api'
import createRefs from '@iez/lib/create-refs/'
import { mask } from 'vue-the-mask'

export default {
  directives: {
    mask
  },

  props: {
    length: {
      type: Number,
      default: 6
    },
    value: String,
    mask: {
      type: String,
      default: `#`
    },
    loading: Boolean,
    error: String
  },

  setup (props, { emit }) {
    const { length } = props

    const inputs = createRefs(
      Array.from({
        length
      }).map((_, i) => `input-${i}`)
    )

    const state = reactive({
      models: Array.from({
        length
      }).map(() => ``)
    })

    watch(
      () => props.value,
      value => {
        if (props.value !== state.models.join(``)) {
          state.models.forEach((_, index) => {
            state.models[index] = value[index] || ``
          })
          inputs[`input-${value.length}`].value[0].focus()
        }
      }
    )

    const onInput = i => {
      if (Number.isInteger(state.models[i]) && i < length - 1) {
        if (state.models[i] > 9) {
          const str = `${state.models[i]}`.split(``)
          str.forEach((char, j) => {
            if (i + j < length) {
              state.models[i + j] = char
              inputs[`input-${i + j}`].value[0].blur()
            }
          })
        } else {
          inputs[`input-${i + 1}`].value[0].focus()
        }
      }
      const result = state.models.join(``)
      if (result.length === length) {
        emit('input', result)
      }
      emit('change', result)
    }

    const onKeyDown = ($event, i) => {
      if ($event.key === `Backspace` && i > 0) {
        if (!Number.isInteger(state.models[i])) {
          inputs[`input-${i - 1}`].value[0].focus()
          state.models[i - 1] = ``
        }
      }
    }

    onMounted(() => {
      Object.values(inputs)
        .forEach(refs => {
          refs.value[0].$el.querySelector(`input`).classList.add(`text-center`)
        })
    })

    return {
      ...toRefs(state),
      ...inputs,
      onInput,
      onKeyDown
    }
  }
}
</script>
